import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';

export const columns = (onDelete, onEye, canRemove) => [
	{
		dataField: 'numero_sesion',
		text: 'No. de Sesión',
		style: { maxWidth: '350px' },
		headerAlign: 'left',
	},
	{
		dataField: 'nombre_corto',
		text: 'Nombre de sesión',
		headerAlign: 'left',
	},
	{
		dataField: 'tipo_sesion',
		text: 'Tipo de Sesión',
		headerAlign: 'left',
		formatter: (cell, row) => {
			if (row.tipo_sesion === 'O') {
				row.tipo_sesion = `Ordinaria`;
			}
			if (row.tipo_sesion === 'E') {
				row.tipo_sesion = `Extraordinaria`;
			}

			return row.tipo_sesion;
		},
	},
	{
		dataField: 'fecha',
		text: 'Fecha de sesión',
		headerAlign: 'left',
	},
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnFormat,
		formatExtraData: {
			onDelete,
			onEye,
			canRemove,
		},
	},
];

export const defaultFilter = {
	organ: '',
	sessionNumber: '',
	startSessionDate: null,
	endSessionDate: null,
};

export const filterForm = (
	onConfirmFilter,
	onClear,
	organs = [],
	disableFilter = false
) => [
	{
		label: '*Órgano Colegiado',
		name: 'organ',
		type: 'dropdown',
		options: [...organs],
		column: 4,
		disabled: disableFilter,
	},
	{
		label: 'Número de Sesión',
		name: 'sessionNumber',
		type: 'text',
		column: 2,
	},
	{
		label: 'Fecha de Inicio',
		name: 'startSessionDate',
		type: 'date',
		column: 2,
	},
	{
		label: 'Fecha de Fin',
		name: 'endSessionDate',
		type: 'date',
		column: 2,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 1,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'info',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
	},
];
export const filterForm2 = (organs = [], disableFilter = false) => [
	{
		label: '*Órgano Colegiado',
		name: 'organ',
		type: 'dropdown',
		options: [...organs],
		column: 3,
		disabled: disableFilter,
	},
];
